import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function UserAdd({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>UserAdd</title>
      <path
        d="M3.25 20C3.25 20.4142 3.58579 20.75 4 20.75C4.41421 20.75 4.75 20.4142 4.75 20H3.25ZM12.75 14.75C13.1642 14.75 13.5 14.4142 13.5 14C13.5 13.5858 13.1642 13.25 12.75 13.25V14.75ZM18.2855 13.9645C18.2855 13.5503 17.9497 13.2145 17.5355 13.2145C17.1213 13.2145 16.7855 13.5503 16.7855 13.9645H18.2855ZM16.7855 21.0355C16.7855 21.4498 17.1213 21.7855 17.5355 21.7855C17.9497 21.7855 18.2855 21.4498 18.2855 21.0355H16.7855ZM21.0711 18.25C21.4853 18.25 21.8211 17.9142 21.8211 17.5C21.8211 17.0858 21.4853 16.75 21.0711 16.75V18.25ZM14 16.75C13.5858 16.75 13.25 17.0858 13.25 17.5C13.25 17.9142 13.5858 18.25 14 18.25V16.75ZM4.75 20V19H3.25V20H4.75ZM14.25 7C14.25 8.79493 12.7949 10.25 11 10.25V11.75C13.6234 11.75 15.75 9.62335 15.75 7H14.25ZM11 10.25C9.20507 10.25 7.75 8.79493 7.75 7H6.25C6.25 9.62335 8.37665 11.75 11 11.75V10.25ZM7.75 7C7.75 5.20507 9.20507 3.75 11 3.75V2.25C8.37665 2.25 6.25 4.37665 6.25 7H7.75ZM11 3.75C12.7949 3.75 14.25 5.20507 14.25 7H15.75C15.75 4.37665 13.6234 2.25 11 2.25V3.75ZM16.7855 13.9645V17.5H18.2855V13.9645H16.7855ZM16.7855 17.5V21.0355H18.2855V17.5H16.7855ZM17.5355 18.25H21.0711V16.75H17.5355V18.25ZM17.5355 16.75H14V18.25H17.5355V16.75ZM4.75 19C4.75 16.6528 6.65279 14.75 9 14.75V13.25C5.82436 13.25 3.25 15.8244 3.25 19H4.75ZM9 14.75H12.75V13.25H9V14.75Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
